import type { FC } from 'react';
import { Box, Text } from '@mantine/core';
import styles from './CreatePartnerOrganization.module.css';
import { useCreatePartnerOrganization } from './CreatePartnerOrganization.hook';
import { titles, subtitles } from './CreatePartnerOrganization.const';
import { Step } from './CreatePartnerOrganization.enum';
import PartnerOrganizationForm from '@/pages/CreatePartnerOrganization/components/PartnerOrganizationForm';
import Onboarding from '@/pages/CreatePartnerOrganization/components/Onboarding/Onboarding.tsx';
import TalkToAgent from '@/pages/CreatePartnerOrganization/components/TalkToAgent';

const CreatePartnerOrganization: FC = () => {
    const { currentStep, handleNext, handleBack } =
        useCreatePartnerOrganization();

    return (
        <Box className={styles.wrapper}>
            <Box className={styles.card}>
                <Box w="100%">
                    {currentStep === Step.AGENT_SETUP ? (
                        <Text
                            className={styles.fadeText}
                            fw={500}
                            fz={14}
                            ta="start"
                        >
                            Your Agent setup is almost done.
                        </Text>
                    ) : undefined}
                    <Text
                        fw={600}
                        fz={32}
                        lh="1.2"
                        mb="xs"
                        ta={
                            currentStep === Step.AGENT_SETUP
                                ? 'start'
                                : 'center'
                        }
                    >
                        {titles[currentStep]}
                    </Text>
                </Box>

                {subtitles[currentStep] ? (
                    <Text
                        className="text-balance	"
                        fw={500}
                        fz={14}
                        mb="lg"
                        ta="center"
                    >
                        {subtitles[currentStep]}
                    </Text>
                ) : undefined}

                {currentStep === Step.ONBOARDING && (
                    <Onboarding handleNext={handleNext} />
                )}

                {currentStep === Step.CREATE_ORGANIZATION && (
                    <PartnerOrganizationForm
                        handleBack={handleBack}
                        handleNext={handleNext}
                    />
                )}

                {currentStep === Step.AGENT_SETUP && (
                    <TalkToAgent
                        handleBack={handleBack}
                        handleNext={handleNext}
                    />
                )}
            </Box>
        </Box>
    );
};

export default CreatePartnerOrganization;
